import React from 'react'
import { motion } from 'framer-motion'
import Navbar from './Navbar'
import { Toaster } from 'react-hot-toast'

const Layout = ({ children, showNavbar = true }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-bg via-white to-secondary-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition-colors duration-300">
      {showNavbar && <Navbar />}
      <motion.main
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={showNavbar ? 'pt-16' : ''}
      >
        {children}
      </motion.main>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--toast-bg)',
            color: 'var(--toast-color)',
            borderRadius: '12px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
            border: '1px solid var(--toast-border)',
          },
          success: {
            iconTheme: {
              primary: '#6ECC78',
              secondary: '#fff',
            },
          },
        }}
      />
      
      {/* CSS Variables for Toast Theming */}
      <style jsx>{`
        :global(:root) {
          --toast-bg: #fff;
          --toast-color: #424242;
          --toast-border: #E2E8F0;
        }
        :global(.dark) {
          --toast-bg: #374151;
          --toast-color: #F9FAFB;
          --toast-border: #4B5563;
        }
      `}</style>
    </div>
  )
}

export default Layout